import CustomStore from 'devextreme/data/custom_store';
import { Http } from '@angular/http';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { GridConfig, calculaAlturaGrid, adicionaIconesGrid } from './../app.config';
import { BancoAgencia } from './banco-agencia.model';
import { NTECH_API } from '../app.api';
import { BancoService } from './../banco/banco.service';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
  selector: 'ntc-banco-agencia',
  templateUrl: './banco-agencia.component.html',
  styleUrls: ['./banco-agencia.component.css']
})
export class BancoAgenciaComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  loadingVisible = false;
  listaBancoAgencia: CustomStore;
  listaBanco = null;
  listaForm = {Id: 'listaBanco', status: false};
  alturaGrid = null;

  showFilterRow = GridConfig.showFilterRow;
  currentFilter = GridConfig.currentFilter;
  showHeaderFilter = GridConfig.showHeaderFilter;
  columnChooser = GridConfig.columnChooser;
  groupPanel = GridConfig.groupPanel;
  searchPanel = GridConfig.searchPanel;
  exportGrid = GridConfig.exportGrid;

  colunasGridBancoAgencia = [];

  editOptionsGridBancoAgencia = {
    mode: GridConfig.gridMode,
    allowUpdating: true,
    allowAdding: true,
    allowDeleting: true,
    popup: {
      title: 'Agência do Banco',
      showTitle: true
    }
  };

  constructor(
    @Inject(Http) http: Http,
    private bancoService: BancoService
  ) {
    this.loadingVisible = true;

    // carrega a lista de Bancos
    this.bancoService.getBancos()
      .subscribe(bancos => {
        this.listaBanco = bancos;
        this.verificarListasCarregadas('listaBanco');
      },
      error => {
        this.verificarListasCarregadas('listaBanco');
      }
    );

    this.listaBancoAgencia = new CustomStore({
      insert: function (values) {
        return http.post(`${NTECH_API}/banco-agencia/`, values).toPromise();
      },
      remove: function (key) {
        return http.delete(`${NTECH_API}/banco-agencia/${encodeURIComponent(key.Id)}`).toPromise();
      },
      update: function (key, values) {
        return http.put(`${NTECH_API}/banco-agencia/${encodeURIComponent(key.Id)}`, Object.assign(key, values)).toPromise();
      },
      load: function (loadOptions: any) {
        return http.get(`${NTECH_API}/banco-agencia/`)
            .toPromise()
            .then(response => response.json())
            .catch(error => { throw 'Erro ao carregar dados.' });
      }
    });
  }

  ngOnInit() {
    this.alturaGrid = calculaAlturaGrid();
  }

  onCellPrepared(e) {
    adicionaIconesGrid(e);
  }

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;

    // Adiciona um novo botao a Toolbar
    toolbarItems.push({
      location: 'after',
      widget: 'dxButton',
      options: {
          icon: 'refresh',
          onClick: this.refreshDataGrid.bind(this)
      }
    });
  }

  refreshDataGrid() {
    this.dataGrid.instance.refresh();
  }

  verificarListasCarregadas(nomeLista: string): boolean {

    // altera o status da lista informada para true
    if (nomeLista !== '') {
      this.listaForm.status = true;
    }

    // verifica os status das listas para montar o form  e retirar o backdrop (loading)
    if (this.listaForm.status === true) {

      this.colunasGridBancoAgencia = [
        {
          dataField: 'Id',
          dataType: 'string',
          caption: 'ID',
          editorOptions: { disabled: true }
        },
        {
          dataField: 'DescricaoBancoAgencia',
          dataType: 'string',
          caption: 'Descrição da Agencia',
          validationRules: [{
            type: 'required',
            message: 'Descrição da Agencia é obrigatório.'
          }]
        },
        {
          dataField: 'IdBanco',
          caption: 'Banco',
          lookup: {
              dataSource: this.listaBanco,
              displayExpr: 'DescricaoBanco',
              valueExpr: 'Id'
          },
          validationRules: [{
            type: 'required',
            message: 'Banco é obrigatório.'
          }]
        }
      ];
      this.loadingVisible = false;

      return true;
    } else {
      return false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/banco-agencia/banco-agencia.component.ts